import { render, staticRenderFns } from "./ServiceIndex.vue?vue&type=template&id=35df9d16"
import script from "./ServiceIndex.vue?vue&type=script&lang=ts"
export * from "./ServiceIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports